export default __webpack_public_path__ + "assets/images/arrow-down-2985b2e7213ad0db6361c8c6aa86e742.svg";